import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const ParentSvg = styled.div`
  font-size: 70px;
  margin-bottom: 1rem;
`;

export const Title = styled.h3`
  color: #6c6c6c;
  font-size: 26px;
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    font-size: 20px;
  }
`;

export const Description = styled.p`
  margin: 1.5rem 0px;
  text-align: center;
  color: #a8a8a8;
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    font-size: 14px;
  }
`;

export const DeliverDetailModal = styled.div`
  padding: ${({ theme }) => `0 ${theme.spacing.x6} ${theme.spacing.x4}`};
  width: 100%;
`;
export const GrayCard = styled.div`
  padding: ${({ theme }) => ` 0 ${theme.spacing.x4} `};
  margin: ${({ theme }) => ` ${theme.spacing.x3} 0`};
  background: ${({ theme }) => theme.palette.boxBackgroundDark};
  box-shadow: ${({ theme }) => theme.boxShadow.sm};
  border-radius: ${({ theme }) => theme.rounded.x3};
`;
export const BtnContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Btn = styled.div`
  font-size: ${({ theme }) => theme.fs.xs};
`;
export const DeliverDetailModalContainer = styled.div`
  width: 420px;
  max-width: 95%;
`;
